import { rest } from 'msw'

import { UserSettingApiModelStub } from '@webapp/platform/iam/data-access/api-models/stubs/UserSettingApiModel.stub'
import { type UserSettingApiModel } from '@webapp/platform/iam/data-access/api-models/UserSettingApiModel'
import { getResponseObject } from '@webapp/tests/getResponseObject'

export const mockGetUserThresholdSettingsSuccess = (
  userId: number,
  data: UserSettingApiModel = UserSettingApiModelStub.build()
) => {
  return rest.get(`/api/v2/user/${userId}/setting`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(data)))
  })
}
